import { VACCINATION_API } from '@/shared/api/constants';

const FARM = '/farm';
const CELL = '/cell';
const ALL = '/all';
const _TASK = '/task';
const _TASK_PENDING = '/taskPending';
const _TASK_CONTROL = '/taskControl';
const ACTIVE = '/active';
const ARCHIVE = '/archive';
const EVENT_PROTOCOL = '/eventProtocol';
const _INDIVIDUAL = '/individual';
const INFO = '/info';
const UTERUS = '/uterusInventoryNumber';

// FARM
/* farm-search-controller */
export const GET_FARM = VACCINATION_API + FARM;

/* farm-save-controller */
export const UPDATE_FARM_BY_ID = (farmId: string) => GET_FARM + `/${farmId}`;

/* farm-cell-save-controller */
export const FARM_CELL = GET_FARM + CELL;

/* farm-cell-delete-controller */
export const FARM_CELL_BY_ID = (cellId: string) => FARM_CELL + `/${cellId}`;
export const CELL_ALL_BY_FARM_ID = (farmId: string) => FARM_CELL + ALL + `/${farmId}`;

// TASK
/* task-search-controller */
export const TASK = VACCINATION_API + _TASK;
export const TASK_PENDING = VACCINATION_API + _TASK_PENDING;
export const TASK_ARCHIVE = TASK + ARCHIVE;
export const TASK_ACTIVE = TASK + ACTIVE;

/* task-event-protocol-save-controller */
export const TASK_PROTOCOL_APPROVE = (id: string) => TASK + EVENT_PROTOCOL + `/${id}`;

/* task-individual-save-controller */
export const TASK_INDIVIDUAL = TASK + _INDIVIDUAL;
export const TASK_INDIVIDUAL_BY_ID = (id: string) => TASK_INDIVIDUAL + `/${id}`;

/* task-control-search-controller */
export const TASK_CONTROL = VACCINATION_API + _TASK_CONTROL;
export const TASK_CONTROL_INFO = TASK_CONTROL + INFO;

// INDIVIDUAL
/* individual-search-controller */
export const INDIVIDUAL = VACCINATION_API + _INDIVIDUAL;
export const INDIVIDUAL_BY_ID = (id: string) => INDIVIDUAL + `/${id}`;
export const INDIVIDUAL_ARCHIVE = INDIVIDUAL + ARCHIVE;
export const INDIVIDUAL_UTERUS = INDIVIDUAL + UTERUS;
